// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Ve","wrapper":"i_Vf","text":"i_Vg","progress":"i_Vh","message":"i_Vi"};